import { Button, styled } from "@mui/material";

const BlueButtonOutlined = styled(Button)({
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    color: '#586A84',
    borderRadius: '6px',
    boxShadow: '0px 4px 7px 2px rgba(64, 82, 137, 0.1)',
    lineHeight: 1.5,
    backgroundColor: 'transparent',
    borderColor: '#405289',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#D7DEF4',
      borderColor: '#405289',
    },
    '&:active': {
      backgroundColor: '#D7DEF4',
      borderColor: '#405289',
    },
    '&:focus': {
      // boxShadow: '0 0 0 0.2rem rgba(22,75,57,.5)',
    },
  });

  export default BlueButtonOutlined;